import Component from "vue-class-component";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { VueBase } from "../Controls/VueBase";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

@Component
export default class Authentication extends VueBase {
	public dataReady = true;
	public userName = "";
	public password = "";

	public onLoginkeyup(e: any): void {
		if (e.key === "Enter") {
			this.login();
		}
	}

	public login(): void {
		this.dataReady = false;
		ServicesFactoryInstance.AuthenticationService.login(this.userName, this.password, (a) => {
			NotificationServiceInstance.SendSuccess("Connexion réussie !");
			ServicesFactoryInstance.AuthenticationService.setToken(a);
			window.location.reload(true);
		}, () => {
			this.dataReady = true;
		});
	}

	public createAccount(): void {
		this.dataReady = false;
		ServicesFactoryInstance.AuthenticationService.register(this.userName, this.password);
		this.dataReady = true;
	}
}



// WEBPACK FOOTER //
// ./src/components/authentication/authentication.ts